import React from 'react';

interface HealthScaleProps {
  score: number;
  size?: number;
}

const HealthScale: React.FC<HealthScaleProps> = ({
  score,
  size = 160
}) => {
  const radius = (size - 20) / 2; // Account for stroke width
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (score / 100) * circumference;

  return (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {/* Background Circle */}
      <svg
        width={size}
        height={size}
        style={{
          position: 'absolute',
          transform: 'rotate(-90deg)'
        }}
      >
        {/* Background track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="rgba(40, 160, 73, 0.2)"
          strokeWidth="10"
          fill="transparent"
        />
        
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#28A049"
          strokeWidth="10"
          strokeLinecap="round"
          fill="transparent"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          style={{
            transition: 'stroke-dashoffset 1s ease-in-out'
          }}
        />
      </svg>

      {/* Center Content */}
      <div style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 800,
          fontSize: '23.63px',
          lineHeight: '1.25em', /* 29.54px / 23.63px = 1.25em */
          textAlign: 'center',
          color: '#000000'
        }}>
          {score}%
        </div>
      </div>

      {/* Fixed ratio containers for proper scaling */}
      <div style={{
        position: 'absolute',
        width: '100%',
        height: '50%',
        top: 0,
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '100%',
            height: '80px'
          }} />
        </div>
      </div>
      
      <div style={{
        position: 'absolute',
        width: '100%',
        height: '50%',
        bottom: 0,
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '100%',
            height: '80px'
          }} />
        </div>
      </div>
    </div>
  );
};

export default HealthScale;
